// Other platforms retain their existing cloud/remote Work composer.
export default function MacLocalWorkHome({ children }) { return children; }
